import { Icon, IconButton } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useState, MouseEvent } from 'react';

const DeleteUser = ({ onClick }: { onClick: () => void }) => {


    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <IconButton
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <Icon>more_vert</Icon>
            </IconButton>
            <Menu
                sx={{ borderRadius: '10px' }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem
                    sx={{ color: '#f53434', mx: '8px' }}
                    onClick={() => {
                        handleClose();
                        onClick();
                    }}>
                    <Icon>delete</Icon>
                    Eliminar</MenuItem>
            </Menu>
        </div>
    );
}

export default DeleteUser;